import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types"
import ModalForm from "../../../../components/modalComponents/ModalForm";

const DeclararNoTengoFaltas = ({ toggleModal, noDeclaroFaltas, extraData }) => {
    const submitLocal = async () => {
        toggleModal();
        await noDeclaroFaltas();
    };

    return (
        <ModalForm
            titulo="Declarar sin faltas"
            width="600px"
            showModal={toggleModal}
            hasSaveButton = {false}
        >
            <div className="modal-body pt-0 pl-0 pb-0">
                <p>
                    Declaro no tener faltas registradas en la sede <strong>{extraData?.NoTengoFaltasQueReportar_SedeAReportar}</strong> correspondientes al periodo <strong>{extraData?.NoTengoFaltasQueReportar_PeriodoAReportar}</strong>.
                </p>
            </div>
            <div className="modal-footer justify-content-end pb-0">
                <button
                    className="btn btn-primary generic-button-ficha mr-2"
                    onClick={submitLocal}>
                    Declarar sin Faltas
                </button>
                <button
                    className="btn btn-primary generic-button-ficha"
                    onClick={() => { toggleModal() }}>
                    Cancelar
                </button>
            </div>
        </ModalForm>
    );
}

DeclararNoTengoFaltas.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default DeclararNoTengoFaltas;